var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-address-book",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8h3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12h3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16h3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/address-book.08e07c68.svg";
export { ForwardRef as ReactComponent };